import { motion, useAnimate, type AnimationSequence } from 'framer-motion'
import { useEffect } from 'react'
import { useGlobalStore } from '../../../../store/global-store'
import type { PositionReturnLuck } from '../../../../store/live/live-notify'
import type { NotifyLuckEarned } from '../../../../types/lives/notifies'
import blue from '../assets/blue.png'
import gold from '../assets/gold.png'
import pink from '../assets/pink.png'
import prata from '../assets/prata.png'
import purpleDark from '../assets/purple-dark.png'
import red from '../assets/red.png'

interface Props {
  toast: NotifyLuckEarned
  position: PositionReturnLuck
}

// contorno escuro -> texto branco fica legível em qualquer badge (prata claro ou escuros)
const textOutline = {
  textShadow:
    '-1px -1px 0 rgba(0,0,0,0.9), 1px -1px 0 rgba(0,0,0,0.9), -1px 1px 0 rgba(0,0,0,0.9), 1px 1px 0 rgba(0,0,0,0.9), 0 2px 3px rgba(0,0,0,0.55)',
} as const

export function Toast({ toast }: Props) {
  const remove = useGlobalStore((state) => state.removeNotifyGiftLuck)

  const [scope, animate] = useAnimate()

  useEffect(() => {
    const sequence: AnimationSequence = [
      [scope.current, { scale: 1, opacity: 1 }, { duration: 1 }],
      [scope.current, { opacity: 0 }, { duration: 2, delay: 1 }],
    ]

    if (toast) {
      animate(sequence).then(() => remove(toast.id))
    }
  }, [toast, scope, animate, remove])

  let imgBackground = blue

  const rt = Number(toast.returnTimes) || 0

  if (rt < 50) {
    // prata (silver) — retornos pequenos (< 50x)
    imgBackground = prata
  } else if (rt < 101) {
    imgBackground = blue
  } else if (rt < 251) {
    imgBackground = pink
  } else if (rt < 501) {
    imgBackground = purpleDark
  } else if (rt < 1000) {
    imgBackground = red
  } else {
    // 1000x ou acima = dourado
    imgBackground = gold
  }

  return (
    <motion.div
      ref={scope}
      className="flex flex-col justify-center items-center gap-10 opacity-0 relative"
      style={{ scale: 0.3 }}
    >
      <div
        className="rounded-full w-56 h-56 flex justify-center items-center relative"
        style={{
          backgroundImage: `url(${imgBackground})`,
          backgroundRepeat: 'no-repeat',
          backgroundPosition: 'center',
          backgroundSize: 'contain',
        }}
      >
        {/* só os números — valor + multiplicador "Nx"; a arte da estrela é o fundo.
            valor longo (jackpot) desce mais um degrau pra não vazar da estrela */}
        <div className="flex flex-col absolute items-center justify-center max-w-[70%]">
          <span
            className={`${String(toast?.returnValues ?? '').length > 7 ? 'text-base' : 'text-2xl'} font-extrabold leading-none text-[#ffd166] text-center`}
            style={textOutline}
          >
            {toast?.returnValues}
          </span>

          <span className="text-sm font-bold leading-none text-white mt-1" style={textOutline}>
            {toast.returnTimes}x
          </span>
        </div>
      </div>
    </motion.div>
  )
}
